import { useContext } from 'react';
import { changeLocale, IntlContextConsumer } from 'gatsby-plugin-react-intl';
import PropTypes from 'prop-types';

import locales from '../../../locales/locales';
import { Context } from '../../Providers/Blade';

import Toggle from './styles';

const LanguageToggle = ({ showShortButton = false, showAlways = false }) => {
  const { resetState } = useContext(Context);
  const handleToggle = lang => {
    // order of function calls affect user experience changing locale
    // taking priority to ensure language change can happen asap
    resetState();
    changeLocale(lang);
    // manually adjust language for onetrust as changing locale
    //  does not refresh the page causing html to not update with the language
    if (window.OneTrust) {
      window.OneTrust.changeLanguage(lang);
    }
    if (window.adaEmbed) {
      window.adaEmbed.setLanguage(lang);
    }
  };

  return (
    <IntlContextConsumer>
      {({ languages, language: currentLocale }) =>
        languages.map(
          language =>
            language !== currentLocale && (
              <Toggle
                key={language}
                type="button"
                onClick={() => handleToggle(language)}
                language={language}
                currentLocale={currentLocale}
                className={`${showShortButton ? 'short' : 'long'} ${showAlways ? 'show' : 'hide'}`}
              >
                {showShortButton
                  ? language.toUpperCase()
                  : locales[language].locale}
              </Toggle>
            ),
        )
      }
    </IntlContextConsumer>
  );
};

LanguageToggle.propTypes = {
  showShortButton: PropTypes.bool,
  showAlways: PropTypes.bool,
};

export default LanguageToggle;
